import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App';
import { startTelemetry } from './lib/telemetry';
import './index.css';

// Debug flight recorder: before anything else fetches (live trainings only).
startTelemetry();

const updateSW = registerSW({
  onNeedRefresh() {
    const banner = document.getElementById('sw-banner');
    if (banner) banner.style.display = 'flex';
  },
  onOfflineReady() {
    console.log('[pwa] offline-ready');
  },
});

document.getElementById('sw-update')?.addEventListener('click', () => {
  void updateSW(true);
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
